import { ReactNode } from 'react';

import { SVGIconType } from '../../../constants/svgIcon';
import { SvgIcon } from '../SVGIcon';

import styles from './AppBar.module.css';

type Props = {
  leading?: ReactNode;
  title?: ReactNode;
  trailing?: ReactNode;
  withBack?: boolean;
  topPosition?: string;
  appBarClassName?: string;
  onClickBack?: () => void;
  height?: number;
};

export const AppBar = ({
  leading,
  title,
  trailing,
  withBack = true,
  topPosition = '0px',
  appBarClassName,
  onClickBack,
  height = 52,
}: Props) => {
  const handleBack = () => {
    window.history.back();
  };

  return (
    <div
      className={`${styles.appBar} ${appBarClassName}`}
      style={{ top: topPosition, height: height }}
    >
      <div className={styles.leading}>
        {withBack && (
          <button
            className={styles.backButton}
            onClick={onClickBack ?? handleBack}
          >
            <SvgIcon
              name={SVGIconType.Arrow}
              color="#333"
              width={24}
              height={24}
            />
          </button>
        )}
        {leading}
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.trailing}>{trailing}</div>
    </div>
  );
};

type backButtonProps = {
  onClickBack?: () => void;
};

export const DefaultBackButton = ({ onClickBack }: backButtonProps) => {
  const handleBack = () => {
    window.history.back();
  };

  return (
    <button className={styles.backButton} onClick={onClickBack ?? handleBack}>
      <SvgIcon name={SVGIconType.Arrow} color="#333" width={24} height={24} />
    </button>
  );
};
